import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-slate-100 border-t border-slate-200 py-3 px-4 mt-auto">
      <div className="flex flex-col items-center justify-center gap-1.5 text-xs text-slate-500">
        <span>© {currentYear} FISL - Tous droits réservés</span>
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <Link to="/mentions-legales" className="hover:text-[#8DC63F] transition-colors" data-testid="footer-mentions-legales">Mentions légales</Link>
          <span className="text-slate-300">•</span>
          <Link to="/rgpd" className="hover:text-[#8DC63F] transition-colors" data-testid="footer-rgpd">Confidentialité</Link>
          <span className="text-slate-300">•</span>
          <Link to="/charte" className="hover:text-[#8DC63F] transition-colors" data-testid="footer-charte">Charte</Link>
          <span className="text-slate-300">•</span>
          <Link to="/procedures-reclamation" className="hover:text-[#8DC63F] transition-colors" data-testid="footer-reclamation">Réclamation</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
